export const ADDON_TYPE_THUMB = {
  parking:     { bg: '#E0E7FF', fg: '#1E40AF', glyph: 'P' },
  transport:   { bg: '#DBEAFE', fg: '#1E3A8A', glyph: 'T' },
  merchandise: { bg: '#FEF3C7', fg: '#8A5A12', glyph: 'M' },
  hospitality: { bg: '#FCE7F3', fg: '#9D174D', glyph: 'V' },
  food:        { bg: '#D1FAE5', fg: '#065F46', glyph: 'F' },
  experience:  { bg: '#FEF9C3', fg: '#854D0E', glyph: 'E' },
  service:     { bg: '#E0E7FF', fg: '#3730A3', glyph: 'S' },
  other:       { bg: '#F2F1ED', fg: '#1F2937', glyph: '+' },
};

// Lives here (not in lib/builders) so data/addons.js can use it without creating
// a data/addons ↔ lib/builders circular import — that cycle caused a TDZ where
// builders' `defaultAddonThumb` const was uninitialized when the addons seed
// (which calls it at module-eval) was evaluated first.
export const defaultAddonThumb = (type) => {
  const t = ADDON_TYPE_THUMB[type] || ADDON_TYPE_THUMB.other;
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><rect width='64' height='64' fill='${t.bg}'/><text x='50%' y='52%' text-anchor='middle' dominant-baseline='middle' font-family='Inter,system-ui,sans-serif' font-size='32' font-weight='700' fill='${t.fg}'>${t.glyph}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};